// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logo {
  width: 300px;
  height: auto;
}

.logoWrapper {
  width: 300px;
  margin: 0 auto;
}
.logoWrapper .logo {
  width: 100%;
  max-height: 300px;
  object-fit: contain;
}

.imgFit {
  width: 100%;
  object-fit: cover;
  height: 100vh;
  max-width: 100% !important;
}

.back {
  height: 100%;
}

.logoWrapper {
  width: 300px;
  margin: 30px auto;
}
.logoWrapper .logo {
  width: 100%;
  max-height: 300px;
  object-fit: contain;
}

.h-100 {
  height: 100vh !important;
}

.login100-form-title {
  display: block;
  color: var(--theme-color-primary);
  text-align: left;
  font-size: 36px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
}`, "",{"version":3,"sources":["webpack://./src/app/authentication/logout/logout.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,YAAA;AACJ;;AAEA;EACI,YAAA;EACA,cAAA;AACJ;AACI;EACI,WAAA;EACA,iBAAA;EACA,mBAAA;AACR;;AAGA;EACI,WAAA;EACA,iBAAA;EACA,aAAA;EACA,0BAAA;AAAJ;;AAGA;EACI,YAAA;AAAJ;;AAKA;EACI,YAAA;EACA,iBAAA;AAFJ;AAII;EACI,WAAA;EACA,iBAAA;EACA,mBAAA;AAFR;;AAMA;EACI,wBAAA;AAHJ;;AAMA;EACI,cAAA;EACA,iCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;AAHJ","sourcesContent":[".logo {\n    width: 300px;\n    height: auto;\n}\n\n.logoWrapper {\n    width: 300px;\n    margin: 0 auto;\n\n    .logo {\n        width: 100%;\n        max-height: 300px;\n        object-fit: contain;\n    }\n}\n\n.imgFit {\n    width: 100%;\n    object-fit: cover;\n    height: 100vh;\n    max-width: 100% !important;\n}\n\n.back {\n    height: 100%;\n    ;\n}\n\n\n.logoWrapper {\n    width: 300px;\n    margin: 30px auto;\n\n    .logo {\n        width: 100%;\n        max-height: 300px;\n        object-fit: contain;\n    }\n}\n\n.h-100 {\n    height: 100vh !important;\n}\n\n.login100-form-title {\n    display: block;\n    color: var(--theme-color-primary);\n    text-align: left;\n    font-size: 36px;\n    font-weight: bold;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: normal;\n    letter-spacing: normal;\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
